import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'bom-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input()
  type: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'unstyled' = 'unstyled';

  @Input()
  text: string = undefined;

  @Input()
  textKey: string = undefined;

  @Input()
  disabled = false;

  @Input()
  showSpinner = false;

  @Output()
  clicked = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}
}
